const e = {
  name: "--pf-v6-c-spinner--diameter",
  value: "3.5rem",
  var: "var(--pf-v6-c-spinner--diameter)"
};
export {
  e as c_spinner_diameter,
  e as default
};
